import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        <span className="h-6 w-1.5 rounded-full bg-accent-500"></span>
        <div>
          <h2 className="text-lg font-bold text-foreground-950 md:text-xl">{title}</h2>
          {subtitle && <p className="mt-0.5 text-xs text-foreground-500 md:text-sm">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="hidden shrink-0 items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-accent-500 sm:flex"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      )}
    </div>
  );
}